import React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { CustomTextField } from "../../helpers/helper";
import { Divider, MenuItem } from "@mui/material";

const CustomAutocomplete = ({
  disabled,
  options,
  value,
  onChange,
  getOptionLabel,
  getOptionDisabled,
  onFocus,
  placeholder,
}) => (
  <Autocomplete
    disabled={disabled}
    disablePortal
    id="combo-box-demo"
    options={options}
    value={value || null}
    onChange={onChange}
    // onClick={handleFetchOrganization}
    getOptionLabel={getOptionLabel}
    getOptionDisabled={getOptionDisabled}
    renderInput={(params) => (
      <CustomTextField
        {...params}
        placeholder={placeholder}
        onFocus={onFocus}
        // sx={{ marginBottom: "20px" }}
      />
    )}
    renderOption={(props, option) => (
      <>
        <MenuItem
          {...props}
          style={{
            fontSize: "14px",
            letterSpacing: "-0.02em",
            lineHeight: "20px",
            fontWeight: 500,
            fontFamily: "Montserrat",
            color: "#5a5a5a",
            textAlign: "left",
          }}
        >
          {getOptionLabel(option)}
        </MenuItem>
        <Divider sx={{ width: "95%", margin: "0px 12px" }} />
      </>
    )}
  />
);

export default CustomAutocomplete;
